<template>
  <div class="sr-pannel">
    <div class="title">{{title}}</div>
    <div class="pannel-box">
      <slot></slot>
    </div>
  </div>
</template>

<!--
  功能：容器组件
  钟宝琴
  时间：2021年2月9日
  版本：v1.0
-->
<script>
export default {
  name: "SrPannel",
  model: {
    prop: "title"
  },
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  methods: {
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrPannel/SrPannel.vue